const tagDataList = {
  default: {
    shareTitle: '플레이존 : SBS play 소개',
    shareDescription: 'SBS play를 소개합니다',
    shareImageUrl: 'https://img2.sbs.co.kr/sns/playzone/playzone.jpg',
    currentUrl: 'https://www.sbs.co.kr/playzone',
    keywords: 'SBS,에스비에스,sbsplay,SBSPLAY,playzone,플레이존,sbs플레이존'
  },
  event: {
    shareTitle: '플레이존 : 브랜드 오픈 이벤트',
    shareDescription: 'SBS play 시즌 2 이벤트 참여하고 제주도항공권, 호텔숙박권 받자!',
    shareImageUrl: 'https://img2.sbs.co.kr/sns/playzone/brand.jpg',
    currentUrl: 'https://www.sbs.co.kr/playzone/event',
    keywords: 'SBS,에스비에스,sbsplay,SBSPLAY,playzone,플레이존,sbs플레이존,이벤트,플레이존이벤트,오픈이벤트,play오픈이벤트'
  }

};

export default function index(pageSection, pageCategory = '') {
  //console.log('pageSection> ' + pageSection);

  let result = { ...tagDataList['default'], ...tagDataList[pageSection] };

  return { ...result };
}

